import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DevExtremeModule } from 'devextreme-angular';
import moment from 'moment';
import {
    AppInformationService,
    CdrUnitOfWork,
    DashboardService,
    SessionInformationService,
    UtilityService
} from 'src/app/core/core.module';
import { HistoryService } from 'src/app/core/history.service';
import { InvoiceStatus } from 'src/app/core/model/entity-model';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    imports: [CommonModule, DevExtremeModule, RouterLink]
})
export class DashboardComponent implements OnInit {
    historyService = inject(HistoryService);

    filter = {
        startDate: new Date(),
        endDate: new Date(),
        //     statusIds: [
        //     InvoiceStatus.Statuses.New,
        //     InvoiceStatus.Statuses.InProcess,
        //     InvoiceStatus.Statuses.Complete,
        //     InvoiceStatus.Statuses.Posted,
        //     InvoiceStatus.Statuses.Review,
        //     InvoiceStatus.Statuses.Reviewed,
        //     InvoiceStatus.Statuses.Queue,
        //     InvoiceStatus.Statuses.Rejected,
        //     InvoiceStatus.Statuses.Paid,
        //     InvoiceStatus.Statuses.Emailed,
        //     InvoiceStatus.Statuses.Printed,
        //     InvoiceStatus.Statuses.PartiallyPaid,
        //     InvoiceStatus.Statuses.WaitingToEmail,

        // ],
        includeDeleted: false
    };
    showPreviousWeek: boolean;
    dashboardInfos: any;
    averageLoadTimes: any;
    revenue: any[] = [];
    tonsDumped: { jobs: any[]; categories: any[] };
    jobCounts: { jobCounts: any[]; totalCount: number };
    jobsUsingTrailer: number;
    inventoryUsage: any;
    dumpstersOnSite: any;
    invoiceInfos: any;
    availabilityInfos: any;
    invoices: any;
    dumpsterMargins: any;
    subbedDumpsters: any;
    lostJobsByDumpster: any;

    chartEntities: any[] = [];
    constructor(
        private uow: CdrUnitOfWork,
        private appInfo: AppInformationService,
        private sessionInfo: SessionInformationService,
        private utility: UtilityService,
        private dashboard: DashboardService
    ) {}

    async ngOnInit() {
        const filter = this.sessionInfo.getItem('dashboard-filter', true);
        if (filter) this.filter = filter;
        else this.setFilter();
        await this.getData();
    }
    setFilter() {
        const start = new Date();
        // 0 = Sun, 1 = Mon, etc.
        const day = start.getDay();
        // -6 if day is Sun; otherwise +1
        let daysPastMonday = start.getDate() - day + (day === 0 ? -6 : 1);
        if (this.showPreviousWeek) daysPastMonday -= 7;
        start.setDate(daysPastMonday);
        const end = moment(start).add(6, 'days').toDate();

        this.filter.startDate = start;
        this.filter.endDate = end;
    }

    async getTimeSpan(mode: string) {
        if (mode == 'week') {
            this.filter.startDate = moment().subtract(1, 'weeks').startOf('week').toDate();
            this.filter.endDate = moment().subtract(1, 'weeks').endOf('week').toDate();
        }
        if (mode == 'month') {
            this.filter.startDate = moment().subtract(1, 'months').startOf('months').toDate();
            this.filter.endDate = moment().subtract(1, 'months').endOf('months').toDate();
        }
        await this.getData();
    }

    async getData() {
        if (!this.filter.startDate || !this.filter.endDate) {
            this.revenue = null;
            this.tonsDumped = null;
            this.jobCounts = null;
            return;
        }

        this.appInfo.pleaseWaitShow();
        this.dashboardInfos = await this.dashboard.getDashboardInfos(this.filter.startDate, this.filter.endDate);
        this.averageLoadTimes = await this.dashboard.getAverageLoadTimes(this.filter.startDate, this.filter.endDate);
        this.dumpstersOnSite = await this.dashboard.getDumpstersOnSite(this.filter.startDate, this.filter.endDate);
        this.invoiceInfos = await this.dashboard.getInvoiceDashboard(this.filter.startDate, this.filter.endDate);
        this.dumpsterMargins = await this.dashboard.getDumpsterAverageMargins(this.filter.startDate, this.filter.endDate);
        this.dumpsterMargins.data = this.dumpsterMargins?.data.filter(x => x.BillAs !== 'Shop');
        this.subbedDumpsters = await this.dashboard.getSubbedDumpsters(this.filter.startDate, this.filter.endDate);
        this.lostJobsByDumpster = await this.dashboard.getLostJobsByDumpster(this.filter.startDate, this.filter.endDate);

        this.tonsDumped = await this.uow.jobs.getTonsDumped(this.filter.startDate, this.filter.endDate);
        this.jobsUsingTrailer = await this.uow.jobs.getJobsUsingTrailer(this.filter.startDate, this.filter.endDate);

        // filter.createdFrom = UtilityService.startOfDay(filter.createdFrom);
        // filter.createdTo = UtilityService.startOfDay(filter.createdTo);
        this.invoices = await this.historyService.invoiceHistory({
            statusIds: [],
            includeDeleted: false,
            invoiceDateFrom: this.filter.startDate,
            invoiceDateTo: this.filter.endDate
        });

        this.inventoryUsage = await this.utility.getDumpsterUsage();

        this.revenue = await this.uow.jobs.getEstimatedRevenue(this.filter.startDate, this.filter.endDate);
        // this.jobCounts = await this.uow.jobs.getJobCounts(this.filter.startDate, this.filter.endDate);
        this.availabilityInfos = await this.dashboard.getAvailabilityInfos(this.filter.startDate, this.filter.endDate);
        this.sessionInfo.setItem('dashboard-filter', this.filter, true);
        this.appInfo.pleaseWaitHide();
    }

    customizeTooltip = e => {};

    async toggleShowPreviousWeek() {
        this.showPreviousWeek = !this.showPreviousWeek;
        this.setFilter();
        await this.getData();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons'
            },
            {
                template: 'toolbarText',
                location: 'after'
            },
            {
                location: 'after',
                widget: 'dxButton',
                locateInMenu: 'always',
                options: {
                    icon: 'refresh',
                    text: 'Reset Filters',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    }
                }
            }
        );
    }

    async createRevenueLines(selectedRows: any) {
        if (!selectedRows) return;
        const jobIds = selectedRows.map(x => {
            return x.id;
        });
        console.log(jobIds);

        this.appInfo.pleaseWaitShow();
        for (let index = 0; index < jobIds.length; index++) {
            const jobId = jobIds[index];
            await this.utility.generateRevenueLines(jobId);
        }

        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    onAvailabilityLegendClick(e) {
        const series = e.target;
        if (series.isVisible()) {
            series.hide();
        } else {
            series.show();
        }
    }
}
